"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockFor = exports.tobe = void 0;
const observable_1 = require("./observable");
const sleep_1 = require("./sleep");
const tobe = (obs, cond) => { var obs_1, obs_1_1; return __awaiter(void 0, void 0, void 0, function* () {
    var e_1, _a;
    if (obs instanceof observable_1.Observable) {
        while (true) {
            if (cond(obs.get()))
                return;
            const newValue = yield obs.change();
            if (cond(newValue))
                return;
        }
    }
    else {
        try {
            for (obs_1 = __asyncValues(obs); obs_1_1 = yield obs_1.next(), !obs_1_1.done;) {
                const value = obs_1_1.value;
                if (cond(value))
                    return;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (obs_1_1 && !obs_1_1.done && (_a = obs_1.return)) yield _a.call(obs_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}); };
exports.tobe = tobe;
const lockFor = (cond, timeout = 50, maxRecuse = null) => __awaiter(void 0, void 0, void 0, function* () {
    while (maxRecuse === null || maxRecuse > 0) {
        yield (0, sleep_1.sleep)(timeout);
        if (cond())
            return;
        if (maxRecuse)
            maxRecuse--;
    }
    throw new Error("lockFor : max recurse depleted");
});
exports.lockFor = lockFor;
//# sourceMappingURL=tobe.js.map